<template>
    <section class="sessions-scheduler" v-if="students">
        <div class="wrapper">
            {{meetingType}}
            <i class="fa fa-remove" @click="$parent.showScheduler=false"></i>
            <form>
                <h3>Schedule Your Student's Mentor Meetings</h3>
                <span class="invalid" v-if="!valid">Please add either only online or only on-campus students to the meeting.</span>
                <div class="form-group" v-if="type==='campus'">
                    <label>Location</label><br>
                    <select class="form-control" v-model="location">
                        <option v-for="location in locations" :value="location.id">{{location.name}}</option>
                    </select>
                </div>
                <div class="form-group">
                    <date-picker :date="date" :option="options"></date-picker>
                </div>
                <div class="form-group">
                    <label>Number of occurances</label><select class="form-control" v-model="repeat">
                        <option v-for="n in 14" :value="n">{{n}}</option>
                    </select class="form-control">
                </div>
                <div class="form-group" v-if="students">
                    <select class="form-control students" v-model="includeStudents" multiple>
                        <option v-for="student in students" class="student" :value="student.id">
                            {{student.firstName}} {{student.lastName}}
                        </option>
                    </select>
                </div>
                <p class="schedule" v-if="date.time !== ''">
                    <span class="underline">{{repeat}} Meeting<span v-if="repeat > 1">s</span></span>
                    will be scheduled starting on
                    <span class="underline">{{date.time | longDate}}</span>
                    <span v-if="repeat > 1">
                        and ending on
                        <span class="underline">{{endTime | longDate}}</span>
                    </span>
                </p>
                <div class="text-center">
                    <button v-if="type==='online'" @click.prevent="addSessions()" type="submit" class="btn btn-success">Schedule Sessions</button>
                    <button v-if="type==='campus'" @click.prevent="addCampusMeetings()" type="submit" class="btn btn-success">Schedule Meetings</button>
                </div>
            </form>
        </div>
    </section>
</template>
<script>
import meetings from '../../services/meetings';

import datepicker from 'vue-datepicker';
import moment from 'moment';
import _ from 'underscore';
import toastr from 'toastr';

export default {
    props: ['members'],
    data() {
        return {
            sessions: [],
            students: null,
            valid: true,
            includeStudents: [],
            repeat: 1,
            date: {
                time: ''
            },
            type: 'online',
            locations: [
                { id: 'remote', name: 'Remote Meeting' },
                { id: 'green_lab', name: 'Characters for Film (Green Lab)' },
                { id: 'orange_lab', name: 'Texturing (Orange Lab)' },
                { id: 'blue_lab', name: 'Characters for Games (Blue)' },
                { id: 'fish_bowl', name: 'Fish Bowl' },
                { id: 'black_lab', name: 'Black Lab' },
                { id: 'penthouse_north', name: 'Penthouse North' },
                { id: 'penthouse_south', name: 'Penthouse South' },
            ],
            location: null,
            options: {
                type: 'min',
                week: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
                month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
                format: 'YYYY-MM-DD HH:mm',
                placeholder: 'Start Date',
                inputStyle: {
                    'border': 'none',
                },
                SundayFirst: true,
                timeoption: {
                    type: 'min',
                    week: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
                    month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
                    format: 'YYYY-MM-DD HH:mm'
                },
                color: {
                    header: '#363636',
                    headerText: '#3cf'
                },
                buttons: {
                    ok: 'Ok',
                    cancel: 'Cancel'
                },
                overlayOpacity: 0.5,
                dismissible: true
            },
        }
    },
    components: {
        'date-picker': datepicker
    },
    mounted() {
        this.setStudents();
        this.scrollMinutes();
    },
    methods: {
        scrollMinutes() {
            this.$nextTick(()=>{
                const dateInput = document.querySelector('.cov-datepicker')
                if (!dateInput) return;
                dateInput.addEventListener('click',()=>{
                    const month = document.querySelector('.cov-picker-box');
                    if (month) {
                        month.addEventListener('click', ()=>{
                            const minBox = document.querySelector('.min-box');
                            if (minBox) {
                                minBox.scrollTop = minBox.scrollHeight;
                            }
                    
                        });
                    }
                    
                })
            });
            
        },
        setStudents() {
            this.students = this.members.filter(function(m) {
                return !m.roles.includes('Mentor') && !m.roles.includes('CampusMentor');
            });
            this.includeStudents = this.students.map(function(s) { return s.id })
        },
        addCampusMeetings() {
            var self = this;

            if (this.valid !== true) {
                toastr.error("Participants must be all either online or on campus");
                return false;
            }

            if (!this.location) {
                toastr.error("Please select a location");
                return false;
            }

            if (!this.date.time || this.date.time.trim() === '') {
                toastr.error("Please set a date and time");
                return false;
            }

            let campusMeetings = [];

            this.includeStudents.push(parseInt(localStorage.user_id));

            for (var i = 0; i < this.repeat; i++) {

                let startTime = moment(this.date.time).add(i, 'weeks');

                let session = {
                    startTime: startTime.toDate(),
                    location: this.location
                }

                if (this.location === 'remote') {
                    session.endTime = moment(startTime).add(3, 'hours').toDate;
                    session.zoomId = localStorage.zoom_id;
                    session.timezone = moment.tz.guess();
                    session.isMentorMeeting = true;
                }

                session.participants = this.includeStudents;
                campusMeetings.push(session);

            }

            meetings.addCampusMeetings(this, campusMeetings).then(function(response) {
                if (response.data.success === true) {
                    toastr.success('Meeting(s) added');
                    response.data.meetings.forEach(function(meeting) {
                        self.$bus.$emit('addMentorMeeting', meeting);
                        self.$parent.showScheduler = false;
                        self.setStudents();
                    });
                } else {
                    toastr.error('Error adding meeting');
                }
            });
        },
        async addSessions() {
            var self = this;

            if (this.valid !== true) {
                toastr.error("Participants must be all either online or on campus");
                return false;
            }

            if (!localStorage.zoom_id || localStorage.zoom_id == "null") {
                toastr.error("Your Zoom account is not connected. Please contact Think Tank administration.");
                return false;
            }

            if (!this.date.time || this.date.time.trim() === '') {
                toastr.error("Please set a date and time");
                return false;
            }

            self.includeStudents.push(parseInt(localStorage.user_id));


            try {
                for (var i = 0; i < this.repeat; i++) {

                    let startTime = moment(this.date.time).add(i, 'weeks');


                    let session = {
                        startTime: startTime.toDate(),
                        endTime: startTime.add(3, 'hours').toDate(),
                        zoomId: localStorage.zoom_id,
                        timezone: moment.tz.guess(),
                        isMentorMeeting: true,
                    }

                    session.participants = self.includeStudents;


                    await meetings.add(self, session).then(function(response) {
                        if (response.data.success === true) {                           
                            
                            self.$bus.$emit('addMentorMeeting', response.data.meeting);
                        }
                    });
                }

                toastr.success('Sessions scheduled');
                self.$bus.$emit('reloadCheckins');
                self.$parent.showScheduler = false;
                self.setStudents();
            } catch (e) {
                console.log(e);
                toastr.error('Error scheduling sessions');
            }
        }
    },
    watch: {

    },
    computed: {
        meetingType() {
            var self = this;
            let roles = [];

            let included = this.students
                .filter(function(s) { return self.includeStudents.includes(s.id) })
                .forEach(function(s) {
                    if (s.transitioned === true) {
                        s.roles = ['CampusStudent'];
                    }
                    s.roles.forEach(function(r) {
                        roles.push(r);
                    })
                })
            roles = _.uniq(roles).filter(function(r) { return !r.includes('Support') && !r.includes('Registrant') && !r.includes('Everyone') });

            if (roles.length > 1) {
                this.valid = false;
                this.type = 'online';
                return;
            } else {
                this.valid = true;
            }

            if (roles[0] === 'Student') {
                this.type = 'online';
            } else {
                this.type = 'campus';
            }

        },
        endTime() {
            return moment(this.date.time).add((this.repeat - 1), 'weeks');
        }
    }
}

</script>
<style lang="scss" scoped>
section {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: transparentize(#363636, .25);
    z-index: 99999999999;
    display: flex;
    align-items: center;
    justify-content: center;

}

.invalid {
    color: red;
    font-weight: 700;
    font-size: 1.6rem;
    display: inline-block;
    margin-bottom: .5rem;
    text-align: center;
}

.fa-remove {
    position: absolute;
    top: 0;
    right: 0;
    cursor: pointer;
}

.wrapper {
    position: relative;
    background: #3F3F3F;
    padding: 2rem;
    width: 600px;

    input,
    select,
    option:not(.student) {
        background: #212121 !important;
        border: none !important;
        display: inline-block;
        width: auto;
    }

    select.students {
        width: 100%;
    }

    label {
        margin-right: 1rem;
    }

}

.meeting-required {
    margin-bottom: 1rem;

    input {
        position: relative;
        top: 2px;
        margin-right: 1rem;
    }
}

</style>
<style>
.hour-box ul {
    display: flex !important;
    flex-direction: column-reverse !important
}
.min-box {
    display: flex !important;
    flex-direction: column!important
}

.cov-date-body,
.cov-date-caption {
    font-family: sans-serif !important;
}

</style>



// WEBPACK FOOTER //
// MentorSessionScheduler.vue?4810d43b